import Vue from 'vue'
import Vuex from 'vuex'
import Users from './modules/users'
import Customers from './modules/customers'
import Products from './modules/products'
import Proposals from './modules/proposals'
import Invoices from './modules/invoices'
import FinancialMovements from './modules/financial_movements'
import CommissionPayments from './modules/commission_payments'
import MarketPlaces from './modules/market_places'
import BrokerCustomersWallets from './modules/./broker_customers_wallets'
import Ai from './modules/ai'
import {makeRandomId} from '@/utils/Utils'

const config = {
    strict: process.env.NODE_ENV !== 'production',
    state: {
        appIsOnline: true,
        pageVisibility: 'visible',
        screenTitle: null,
        modals: [],
        menuDesktopState: 'expanded',
        crudNotifications: {},
        fcmToken: null,
        fcmData: null,
    },
    mutations: {
        changeAppIsOnline(state, is) {
            state.appIsOnline = is;
        },
        changePageVisibility(state, statePage) {
            state.pageVisibility = statePage;
        },
        changeScreenTitle(state, tlt) {
            state.screenTitle = tlt;
        },
        addModal(state, modal) {
            modal.id = makeRandomId();
            state.modals.push(modal);
        },
        destroyModal(state, id) {
            state.modals.deleteObject({id: id});
        },
        changeMenuState(state, stateMenu) {
            state.menuDesktopState = stateMenu;
        },
        changeFcmToken(state, payload) {
            state.fcmToken = payload;
        },
        changeFcmData(state, payload) {
            state.fcmData = payload;
        },
        changeCrudNotifications(state, payload) {
            state.crudNotifications = payload;
        },
    },
    getters: {
        screenTitle: state => {
            return state.screenTitle;
        },
        modals: state => {
            return state.modals
        },
        appIsOnline(state) {
            return state.appIsOnline
        },
        pageVisibility: state => state.pageVisibility,
        menuDesktopState: state => state.menuDesktopState,
        crudNotifications: state => state.crudNotifications,
        fcmToken: state => state.fcmToken,
        fcmData: state => state.fcmData,
    },
    actions: {
        changeScreenTitle({commit}, tlt) {
            commit('changeScreenTitle', tlt);
        },
        changeCrudNotifications({commit}, payload) {
            commit('changeCrudNotifications', payload);
        },
        changeFcmToken({commit}, payload) {
            commit('changeFcmToken', payload);
        },
        changeFcmData({commit}, payload) {
            commit('changeFcmData', payload);
        }
    },
    modules: {
        users: Users,
        products: Products,
        proposals: Proposals,
        customers: Customers,
        financial_movements: FinancialMovements,
        invoices: Invoices,
        commission_payments: CommissionPayments,
        market_places: MarketPlaces,
        broker_customers_wallets: BrokerCustomersWallets,
        ai: Ai
    },
    plugins: []
};

if (window.addEventListener) {
    config.plugins.push(store => {
        window.addEventListener("online", () => {
            store.commit('changeAppIsOnline', true)
        }, false);
        window.addEventListener("offline", () => {
            store.commit('changeAppIsOnline', false)
        }, false);
        window.addEventListener('visibilitychange', () => {
            store.commit('changePageVisibility', document.visibilityState, false);
        })
    })
}

Vue.use(Vuex);

//export default config

export default new Vuex.Store(config);
